module.exports = __webpack_public_path__ + "img/terror-blade.b365c5d9.jpg";